<template>
  <div class="tab-pane">
    <div class="row mb-3 mt-3">
      <div class="col-md-3">
        <b-button-group v-if="userType !== 'student'">
          <b-button variant="outline-danger">
            <input v-model="selectAll" type="checkbox" @change="selectItemAll(selectAll)" />
          </b-button>
          <b-button variant="outline-danger" type="button" :disabled="recordIds.length == 0" @click="multiDelete"
            v-if="  ['super_admin','distribution'].includes($role)">
            <i class="fa fa-trash" />
            {{ $t("site.bulk_delete") }}
          </b-button>
        </b-button-group>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <input v-model="search" type="text" autofocus class="form-control" :placeholder="$t(`site.search`)"
            @input="(val) => searchChange(val)" />
        </div>
      </div>
      <div class="col-3">
        <div class="float-md-right pt-1">
          <span class="text-muted text-small mr-1 mb-2">
            {{ from }}:{{ to }}
          </span>

          <b-dropdown id="ddown2" right :text="`${perPage}`" variant="outline-warning" size="xs">
            <b-dropdown-item v-for="(size, index) in [5, 10, 20, 50, 100]" :key="index" @click="changePageSize(size)">{{
                size
            }}</b-dropdown-item>
          </b-dropdown>
          <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 overflow-auto">
        <b-table :stacked="($mobile==1)"  ref="table" class="vuetable" sort-by="start_in" sort-desc.sync="false" :current-page="currentPage"
          :fields="bootstrapTable.fields" :items="dataProvider">
          <template v-if="userType !== 'student'" #cell(checkbox)="data">
            <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">
              <input v-model="recordIds" type="checkbox" :value="data.item.id" @change="selectItem(data)" />
              <span />
            </label>
          </template>
          <template #cell(description)="data">
            <div v-html="data.item.description"></div>
          </template>
          <template #cell(room_id)="data">
            {{ data.item.room.name }}
          </template>
          <template #cell(start_in)="data">
            <div>
              {{ GetDateTimeZone(data.item.start_in) }}
            </div>
          </template>
          <template #cell(end_in)="data">
            <div>
              {{ GetDateTimeZone(data.item.end_in) }}
            </div>
          </template>
          <template #cell(api_category)="data">
            <h6>
              <span class="badge badge-success">{{
                  $t("online_session." + data.item.api_category)
              }}</span>
            </h6>
          </template>
          <template #cell(action)="data">
            <template v-if="checkTime(data.item)">
              <b-badge class="badge-glow"> لم تبدأ بعد </b-badge>
            </template>

            <b-dropdown block :text="$t('site.action')" variant="outline-primary"
              v-else-if="data.item.api_category == 'online_class'" style="width: 200px">
              <b-dropdown-item @click="openLive(data)" v-if="data.item.is_end == 0">
                <i class="fas fa-door-open" style="display: inline-block; margin: ; padding: 1px 5px"></i>
                <span class="text-warning">دخول المحاضرة </span>
              </b-dropdown-item>
              <b-dropdown-item v-if="userType != 'student' && data.item.is_end == 0">
                <a style="padding: 5px; cursor: pointer" class="dropdown-item get-online-session-links"
                  @click="end(data.item)">
                  <i class="fas fa-stop-circle" style="display: inline-block; margin: 0; padding: 1px 5px"></i>
                  <span class="text-danger" style="display: inline-block; margin: 0; padding: 1px 5px">
                    إنهاء الاجتماع</span>
                </a>
              </b-dropdown-item>
              <b-dropdown-item v-if="userType != 'student'" @click="reopen(data.item)">
                <a style="padding: 5px; cursor: pointer" class="dropdown-item get-online-session-links">
                  <i class="fas fa-redo" style="display: inline-block; margin: 0; padding: 1px 5px"></i>
                  <span class="text-success" style="display: inline-block; margin: 0; padding: 1px 5px">
                    اعادة الفتح</span>
                </a>
              </b-dropdown-item>
              <b-dropdown-item v-if="data.item.is_end == 1" :to="{
                name: 'OnlineDetails',
                params: {
                  id: data.item.id,
                },
              }">
                <a style="padding: 5px; cursor: pointer" class="dropdown-item get-online-session-links">
                  <i class="fas fa-photo-video" style="display: inline-block; margin: 0; padding: 1px 5px"></i>
                  <span class="text-info" style="display: inline-block; margin: 0; padding: 1px 5px">
                    تحميل ملف الفيديو</span>
                </a>
              </b-dropdown-item>

              <b-dropdown-item v-if="userType != 'student' && data.item.is_end == 1" @click="setData(data.item)" :to="{
                name: 'SessionAttendance',
                params: {
                  session_room_id: data.item.room_id,
                  session_id: data.item.id,
                },
              }">
                <a style="padding: 5px; cursor: pointer" class="dropdown-item get-online-session-links">
                  <i class="fas fa-clipboard-check" style="display: inline-block; margin: 0; padding: 1px 5px"></i>
                  <span class="text-info" style="display: inline-block; margin: 0; padding: 1px 5px">
                    {{ $t("attendance.attendance_record") }}</span>
                </a>
              </b-dropdown-item>
              <!-- <b-dropdown-item>
                <a
                  style="padding: 5px; cursor: pointer"
                  class="dropdown-item get-online-session-links"
               
                >
                  <i
                    class="fas fa-volume-up"
                    style="display: inline-block; margin: 0; padding: 1px 5px"
                  ></i>
                  <span
                    class="text-info"
                    style="display: inline-block; margin: 0; padding: 1px 5px"
                    >تحميل الملف الصوتي</span
                  >
                </a>
              </b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item>
                <a
                  style="padding: 5px; cursor: pointer"
                  class="dropdown-item get-online-session-links"
                  
                >
                  <i
                    class="fas fa-file"
                    style="display: inline-block; margin: 0; padding: 1px 5px"
                  ></i>
                  <span
                    class="text-info"
                    style="display: inline-block; margin: 0; padding: 1px 5px"
                    >تحميل الملفات</span
                  >
                </a></b-dropdown-item
              > -->
            </b-dropdown>
            <b-button v-else variant="success" class="btn-icon" :href="data.item.attr.start_url_zoom" target="_blank">
              <feather-icon icon="CastIcon" />
            </b-button>
          </template>
          <template #cell(end)="data">
            <b-badge variant="success" v-if="data.item.is_end == 0 && !checkTime(data.item)">
              <feather-icon icon="CameraIcon" class="mr-25" />
              <span>نشط</span>
            </b-badge>
            <b-badge v-else>
              <feather-icon icon="CameraOffIcon" class="mr-25" />
              <span>غير نشط</span>
            </b-badge>
          </template>
          <template #cell(attendance_record)="data">
            <b-button variant="info" class="btn btn-icon btn-info" :to="{
              name: 'SessionAttendance',
              params: {
                session_room_id: data.item.room_id,
                session_id: data.item.id,
              },
            }">
              {{ $t("attendance.attendance_record") }}
            </b-button>
          </template>

          <template #cell(edit)="data">
            <button class="btn btn-icon btn-warning btn-sm" @click="editItem(data)">
              <i class="fa fa-edit" />
            </button>
            <button class="btn btn-icon btn-danger btn-sm" @click="deleteItem(data)" v-if=" ['super_admin','distribution'].includes($role)">
              <i class="fa fa-trash" />
            </button>
          </template>
        </b-table>

        <hr />
        <b-pagination v-model="currentPage" align="right"
          class="dataTables_paginate paging_simple_numbers pagination-warning" :total-rows="totalRows"
          :per-page="perPage">
          <template v-slot:next-text>
            <i class="fas fa-angle-left" />
          </template>
          <template v-slot:prev-text>
            <i class="fas fa-angle-right" />
          </template>
          <template v-slot:first-text>
            <i class="fas fa-step-forward" />
          </template>
          <template v-slot:last-text>
            <i class="fas fa-step-backward" />
          </template>
        </b-pagination>

        <!-- end of table -->
      </div>
      <!-- end of col -->
    </div>
    <!-- end of row -->
    <b-modal id="modal-info" ok-variant="info" :ok-title="$t('site.add')" :cancel-title="$t('site.cancel')"
      :ok-disabled="invalid" modal-class="modal-info" centered @ok="submit" size="lg"
      :title="$t('attendance.ask_for_excuse')">
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <b-col cols="12">
              <validation-provider #default="{ errors }" :name="$t('apology.reason')" vid="reason" rules="required">
                <b-form-group class="mb-2">
                  <ckeditor :config="{ contentsLangDirection: 'rtl',versionCheck : false }" v-model="newData.reason"
                    :placeholder="$t('apology.reason')" :state="errors.length > 0 ? false : null" />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import controller from "../../../../Controllers/OnlineSessionController";
import config from "../../../../config/config";
import Auth from "../../../../Apis/Auth";
import SettingController from "@/Controllers/SettingController";
const ctr = new controller();
export default {
  name: "OnlineSessionDataTable",
  props: ["items", "editItem", "now"],
  data() {
    return {
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          { key: "checkbox", label: "", sortable: false },
          {
            key: "id",
            label: this.$i18n.t("site.id"),
            sortable: true,
          },
          {
            key: "title",
            label: this.$i18n.t("online_session.title"),
            sortable: true,
          },
          {
            key: "room_id",
            label: this.$i18n.t("rooms.room"),
            sortable: true,
          },

          {
            key: "start_in",
            label: this.$i18n.t("online_session.start_in"),
            sortable: true,
          },

          {
            key: "api_category",
            label: this.$i18n.t("online_session.api_category"),
            sortable: true,
          },
          {
            key: "end",
            label: this.$i18n.t("online_session.active"),
            sortable: true,
          },
          {
            key: "action",
            label: this.$i18n.t("site.action"),
            sortable: false,
          },
          { key: "edit", label: this.$i18n.t("site.action"), sortable: false },
        ],
      },
      data: {},
      newData: {},
      selectAll: false,

      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      userType: Auth.USER.account_type,
      user: Auth.USER,
    };
  },
  async created() {
    this.time = await new SettingController().time();
    if (this.now) this.bootstrapTable.fields.splice(8, 1);
  },
  methods: {
    GetDateTimeZone(date) {
      return Auth.GetDateTimeZone(date);
    },
    checkTime(item) {
      const check = new Date(this.time.SERVERTIME);
      const stDate = Auth.GetDateTimeZone(item.start_in, true);
      if (check.getTime() >= stDate.getTime()) return false;
      return true;
    },
    async end(item) {
      ctr.end({ id: item.id, meetingID: item.id });
      this.$refs.table.refresh();
    },
    async reopen(item) {
      await ctr.reopen(item.id);
      this.$refs.table.refresh();
    },
    openLive(data) {
      ctr.joinLecture(data.item.id);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    getRecordings(data) {
      ctr.getRecordings(data.item.attr.onlline_class_id);
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await ctr.GetAll(this.apiParamsConverter());
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data = data.data;
      this.load = false;
      return data.data;
    },
    apiParamsConverter() {
      let apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }

      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${this.params.sortDesc ? "desc" : "asc"
          }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }
      if (Auth.USER.account_type != "teacher") {
        let id = localStorage.getItem("eduProgram");
        let room = Auth.ROOM.find((a) => a.edu_program_id == id);
        if (room) apiParams.filter = "room_id|" + room.id;
      }

      if (this.now) apiParams.now = true;
      // if(Auth.USER.account_type=="teacher"){
      //   apiParams.room_id=room.id;
      // }
      apiParams.with = ["room"];
      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        console.log(this.data);
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
    deleteItem(data) {
      ctr.Delete(data.item.id, [], this.$refs.table);
    },
    multiDelete() {
      ctr.Delete(0, this.recordIds, this.$refs.table);
    },
  },
};
</script>
